PROGRAM DansUserProject;

{$R *.dres}

USES
  Vcl.Forms,
  WEBLib.Forms,
  DansUserMain IN 'DansUserMain.pas'{*.html};

{$R *.res}

BEGIN
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.Run;

END.
